/* CPAP homepage refresh — light interactions: For-You tabs, quick add-to-cart, recently-viewed. */
(function () {
  'use strict';
  if (window.__cpapHomeInit) return;
  window.__cpapHomeInit = true;

  /* ---------- Carousel arrows ---------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-scroll]');
    if (!arrow) return;
    var scope = arrow.closest('[data-scroll-scope]') || document;
    var track = scope.querySelector('.hscroll');
    if (!track) return;
    var amount = (track.querySelector('*') ? track.querySelector('*').offsetWidth + 16 : 280) * 2;
    track.scrollBy({ left: arrow.getAttribute('data-scroll') === 'prev' ? -amount : amount, behavior: 'smooth' });
  });

  /* ---------- For You: tab switching ---------- */
  document.querySelectorAll('[data-foryou]').forEach(function (root) {
    var tabs = root.querySelectorAll('.foryou-tab');
    var panels = root.querySelectorAll('.foryou-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-panel') === idx); });
      });
    });
  });

  /* ---------- Quick add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    // Ask Shopify to render the cart-drawer section(s) alongside the add, so the
    // flyout can morph straight to the new cart in one shot (no empty flash).
    // Mirrors stock product-form.js. Falls back to a fresh section fetch in
    // cart-items-component if `sections` is absent from the response.
    var sectionIds = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
        return el.getAttribute('data-section-id');
      })
      .filter(Boolean);
    var items = [{ id: Number(id), quantity: Number(btn.getAttribute('data-qty-value')) || 1 }];
    // Machine PDP with a choose-one free gift: add the chosen gift with the machine.
    if (btn.closest('.cpap-pdp') && typeof window.cdwGwpGiftItems === 'function') {
      items = items.concat(window.cdwGwpGiftItems());
    } else if (btn.closest('.cpap-pdp') && typeof window.cdwGwpChoiceItem === 'function') {
      var gift = window.cdwGwpChoiceItem();
      if (gift) items.push(gift);
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Add failed');
        // Notify the theme's cart drawer to refresh / open. Pass the rendered
        // sections under detail.data so cart-items-component morphs immediately.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'cpap-home', sections: res.d && res.d.sections } }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
        window.location.href = '/cart';
      });
  });

  /* ---------- Recently viewed (from localStorage) ---------- */
  try {
    var wrap = document.querySelector('[data-recently-viewed]');
    var empty = document.querySelector('[data-recently-empty]');
    if (wrap) {
      var items = JSON.parse(localStorage.getItem('cdw_recently_viewed') || '[]');
      if (Array.isArray(items) && items.length) {
        wrap.innerHTML = items.slice(0, 10).map(function (p) {
          var img = p.image
            ? '<img src="' + p.image + '" alt="" width="400" loading="lazy">'
            : '<span class="ph-label">' + (p.handle || '') + '</span>';
          return (
            '<a class="card pcard" href="' + (p.url || '#') + '">' +
              '<div class="pcard-img ph ph-sky">' + img + '</div>' +
              '<div class="pcard-body">' +
                (p.brand ? '<div class="pcard-brand">' + p.brand + '</div>' : '') +
                '<div class="pcard-name">' + (p.title || '') + '</div>' +
                '<div class="pcard-price"><span class="p">' + (p.price || '') + '</span></div>' +
              '</div>' +
            '</a>'
          );
        }).join('');
        wrap.hidden = false;
        if (empty) empty.style.display = 'none';
      }
    }
  } catch (e) { /* no-op */ }
})();
